import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Divider } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { useDispatch, useSelector } from 'react-redux';
import { togglePaymentModal } from '../../reducers/UiReducer';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 400,
	bgcolor: 'background.paper',
	border: '2px solid #000',
	boxShadow: 24,
	p: 4,
};

export default function PayModal() {
	const [open, setOpen] = React.useState(false);
	const handleOpen = () => setOpen(true);
	const { paymodal } = useSelector((state) => state.ui);
	const dispatch = useDispatch();
	const handleClose = () => {
		dispatch(togglePaymentModal(false));
	};

	return (
		<div>
			{/* <Button onClick={handleOpen}>Open modal</Button> */}
			<Modal
				open={paymodal}
				// onClose={handleClose}
				aria-labelledby='modal-modal-title'
				aria-describedby='modal-modal-description'>
				<Box sx={style}>
					<Typography id='modal-modal-title' variant='h6' component='h2'>
						Confirm Your Booking Amount
					</Typography>
					<Divider />
					<Box style={{ display: 'flex', justifyContent: 'space-between' }}>
						<Typography id='modal-modal-description' sx={{ mt: 2 }}>
							ORDERID
						</Typography>
						<Typography
							id='modal-modal-description'
							sx={{ mt: 2 }}
							style={{ fontWeight: 'bold' }}>
							MFBD96666
						</Typography>
					</Box>{' '}
					<Divider style={{ marginTop: 20 }} />
					<Box style={{ display: 'flex', justifyContent: 'space-between' }}>
						<Typography id='modal-modal-description' sx={{ mt: 2 }}>
							AMOUNT
						</Typography>
						<Typography
							id='modal-modal-description'
							sx={{ mt: 2 }}
							style={{ fontWeight: 'bold' }}>
							₹84574
						</Typography>
					</Box>
					{false ? (
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								marginTop: 10,
								justifyContent: 'center',
							}}>
							{' '}
							<CircularProgress style={{ marginRight: 10 }} />
							Please wait....
						</div>
					) : (
						<>
							<button
								style={{
									backgroundColor: 'rgb(63 173 88)',
									color: 'white',
									// borderColor: '#E61855',
									borderRadius: 5,
									width: '100%',
									padding: 14,
									fontSize: 16,
									cursor: 'pointer',
									marginBottom: 20,
									marginTop: 30,
									'&:hover': {
										backgroundColor: '#E61855',
									},
								}}
								// onClick={handlePayment}
							>
								Proceed to Payment{' '}
							</button>
							<button
								style={{
									backgroundColor: '#E61855',
									color: 'white',
									// borderColor: '#E61855',
									borderRadius: 5,
									width: '100%',
									padding: 14,
									fontSize: 16,
									cursor: 'pointer',
									marginBottom: 20,
									marginTop: 10,
									'&:hover': {
										backgroundColor: '#E61855',
									},
								}}
								onClick={handleClose}>
								Cancel
							</button>
						</>
					)}
				</Box>
			</Modal>
		</div>
	);
}
